export default "__VITE_ASSET__mL2jIzZf__"